import {i18n} from '@/plugins/i18n'

export const companies = {
    PAYSTAR: 1,
    CASPIAN: 2,
};


export const companiesStr = {
    PAYSTAR: i18n.t('companies.paystar'),
    CASPIAN: i18n.t('companies.caspian'),

    get(status) {
        let company_str = '-';

        Object.keys(companies).forEach(item => {
            if (companies[item] === status) {
                company_str = companiesStr[item];
            }
        });

        return company_str;
    }
};

export const companiesVariant = (status) => {
    switch (status) {
        case companies.PAYSTAR:
            return 'success';
        case companies.CASPIAN:
            return 'info';
    }
    return '';
};
